{
  "api-enums-quoted": "Quoted",
  "api-enums-hired": "Hired",
  "api-enums-simulated": "Simulated",
  "api-enums-to-be-renewed": "To Be Renewed",
  "api-enums-settled": "Settled",
  "api-enums-purchase": "Purchase",
  "api-enums-sale": "Sale",
  "api-enums-import": "Import",
  "api-enums-export": "Export",
  "api-enums-loan4131": "External Repass (4131)",
  "api-enums-foreign_repass": "",
  "api-enums-indicative": "",
  "api-enums-open": "In open",
  "api-enums-loan": "loan",
  "api-enums-credit-acquisition-acc": "Advance on Exchange Contract",
  "api-enums-credit-acquisition-ace": "Advance on Delivered Exchange Contracts",
  "api-enums-credit-acquisition-cdc": "CDC",
  "api-enums-credit-acquisition-ccb": "CCB",
  "api-enums-credit-acquisition-cce": "CCE",
  "api-enums-credit-acquisition-bndes": "National Bank for Economic and Social Development",
  "api-enums-credit-acquisition-working-capital": "Working Capital",
  "api-enums-credit-acquisition-automaker-cdc": "Automaker CDC",
  "api-enums-credit-acquisition-finimp": "Finimp",
  "api-enums-credit-acquisition-leasing": "Leasing",
  "api-enums-credit-acquisition-mutuo": "Mutuo",
  "api-enums-credit-acquisition-export-credit-note": "Export Credit Note",
  "api-enums-credit-acquisition-external-transfer": "External Transfer",
  "api-enums-credit-acquisition-pre-export-payment": "Pre-Export Payment",
  "api-enums-export-hedge": "Export Hedge",
  "api-enums-import-hedge": "Import Hedge",
  "api-enums-low": "Low",
  "api-enums-medium": "Medium",
  "api-enums-high": "High",
  "api-enums-in-progress": "In Progress",
  "api-enums-completed": "Completed",
  "api-enums-not-started": "",
  "api-enums-open1": "Open pending",
  "api-enums-overdue": "overdue",
  "api-enums-foreign-repass": "Foreign Repass",
  "api-enums-loan-operation-type-foreign-repass": "",
  "api-enums-loan-operation-type-ace": "",
  "api-enums-loan-operation-type-acc": "",
  "api-enums-loan-operation-type-bndes": "",
  "api-enums-loan-operation-type-working-capital": "",
  "api-enums-loan-operation-type-manufacturer-financing": "",
  "api-enums-loan-operation-type-direct-consumer-credit": "",
  "api-enums-loan-operation-type-bank-credit-note": "",
  "api-enums-loan-operation-type-export-credit-ballot": "",
  "api-enums-loan-operation-type-finimp": "",
  "api-enums-loan-operation-type-leasing": "",
  "api-enums-loan-operation-type-loan": "",
  "api-enums-loan-operation-type-export-credit-note": "",
  "api-enums-loan-operation-type-export-prepayment": "",
  "api-enums-bank-manager-position-general-manager": "General Manager",
  "api-enums-bank-manager-position-relationship-manager": "Relationship Manager",
  "api-enums-bank-manager-position-business-manager": "Business Manager",
  "api-enums-bank-manager-position-corporate-manager": "Corporate Manager",
  "api-enums-bank-manager-position-commercial-officer": "Commercial Officer",
  "api-enums-bank-manager-position-assistant-manager": "Assistant Manager",
  "api-enums-bank-manager-position-client-specialist": "Client Specialist",
  "api-enums-bank-manager-position-credit-analyst": "Credit Analyst",
  "api-enums-bank-manager-position-credit-desk": "Credit Desk",
  "api-enums-bank-manager-position-derivatives-desk": "Derivatives Desk",
  "api-enums-bank-manager-position-trader": "Trader",
  "api-enums-bank-manager-position-risk-analyst": "Risk Analyst",
  "api-enums-bank-manager-position-risk-manager": "Risk Manager",
  "api-enums-bank-manager-position-other": "Other",
  "api-enums-within-band": "Within Band",
  "api-enums-attention": "Attention",
  "api-enums-action-needed": "Action Needed",
  "api-enums-risk-event": "Risk Event",
  "api-enums-committee-decision": "Committee Decision",
  "auth-welcome-message": "Welcome!",
  "auth-login-prompt": "Log in to get started.",
  "auth-field-email": "Email",
  "auth-field-password": "Password",
  "auth-field-password-confirmation": "Confirm the Password",
  "auth-at-least8-characters": "At least 8 characters",
  "auth-at-least1-capital-letter": "At least 1 capital letter (A-Z)",
  "auth-at-least1-number": "At least 1 number (0-9)",
  "auth-at-least1-symbol": "At least one symbol (#$&)",
  "auth-to-define": "To Define",
  "auth-remember-password-message": "Remember password on this device",
  "auth-sigin-button": "Sign In",
  "auth-last-password-label": "Forgot password?",
  "auth-first-access-label-q": "First access?",
  "auth-first-access-label": "First access",
  "auth-define-password-to-access": "Set your password to access the Vault system",
  "auth-login-validating-credentials": "Validating credentials...",
  "auth-login-auth-success": "Authentication successful!",
  "auth-login-getting-permissions": "Getting permissions...",
  "auth-invalid-token-title": "Invalid Token",
  "auth-invalid-token-message": "The token received during authentication is not valid.",
  "auth-access-token-renewed-title": "Access Renewed",
  "auth-access-token-renewed-success": "Authentication token successfully renewed",
  "auth-access-token-renewed-error": "There was an error renewing the access token, please log in again",
  "auth-access-token-renewal-in-progress": "Your access token is about to expire, automatic renewal in progress",
  "auth-access-token-renewal-title": "Access Renewal",
  "auth-recover-password-title": "Password Recovery",
  "auth-recover-password-success": "If the provided email address is correct, you will receive a link shortly to create a new password",
  "auth-recover-password-instructions": "Enter your email to receive instructions",
  "auth-password-created-successfully": "Password created successfully",
  "auth-password-updated-successfully": "Password updated successfully",
  "auth-error-creating-password": "Error creating password",
  "auth-error-updating-password": "Error updating password",
  "auth-error-login": "Invalid Email or Password",
  "auth-confirm-send-password-recovery-email": "Are you sure you want to send the password recovery email to the user?",
  "auth-password-recovery-link1": "Link for password recovery",
  "auth-additional-costs": "Additional costs",
  "calendar-january": "January",
  "calendar-february": "February",
  "calendar-march": "March",
  "calendar-april": "April",
  "calendar-may": "May",
  "calendar-june": "June",
  "calendar-july": "July",
  "calendar-august": "August",
  "calendar-september": "Aeptember",
  "calendar-october": "October",
  "calendar-november": "November",
  "calendar-december": "December",
  "calendar-confirm-cancel": "Are you sure you want to cancel?",
  "calendar-create": "Create",
  "comex-comex-control": "Comex",
  "comex-number-of-operations": "Number of operations",
  "comex-percentage-of-down-payments-made": "Percentage of Down Payments made",
  "comex-average-cost-of-lcs": "Average cost of LCs",
  "comex-comex-operations": "Comex Operations",
  "comex-error-loading-kpis": "Error Loading KPIs",
  "comex-error-loading-comex-operations": "Error loading comex operations",
  "comex-operation-updated-successfully1": "Operation Updated Successfully",
  "comex-error-updating-operation1": "Error Updating Operation",
  "comex-operation-created-successfully1": "Operation created successfully",
  "comex-error-creating-operation1": "Error Creating Operation",
  "comex-stage-saved-successfully": "Stage saved successfully",
  "comex-error-saving-step": "Error saving step",
  "comex-reference1": "Reference",
  "comex-supplier": "Supplier",
  "comex-fob-value": "Fob Value",
  "comex-tax-value": "Tax Value",
  "comex-freight-value": "Freight Value",
  "comex-foreign-currency-value": "Value in foreign currency",
  "comex-comex-registration": "Comex Registration",
  "comex-negotiation-and-formalization": "Negotiation and Formalization",
  "comex-financial-execution": "Financial Execution",
  "comex-down-payment": "down payment",
  "comex-percentage": "percentage",
  "comex-tax1": "tax",
  "comex-term": "term",
  "comex-flow1": "flow",
  "comex-payment-condition": "Payment Condition",
  "comex-data-down-payment": "Data Down Payment",
  "comex-bank-down-payment": "Bank Down Payment",
  "comex-data-de-atracacao": "Docking Date",
  "comex-shipping-date": "Shipping Date",
  "comex-load-forecast": "Load Forecast",
  "comex-real-value": "Real Value",
  "comex-due-date-lc": "Due Date of the LC",
  "comex-lc-value": "Value of the LC",
  "comex-data-emissao": "Issue Date",
  "comex-banco-lc": "Banco LC",
  "comex-payment-lc": "Payment LC",
  "comex-real-cost-lc": "Real Cost LC",
  "comex-annual-cost-flat-lc": "Annual Cost LC Flat",
  "comex-attachment-lc": "Attachment LC",
  "comex-save-operation-first": "Save Operation First",
  "comex-hedge-contratado": "Hedge Contracted",
  "comex-waiting-for-production": "Waiting for Production",
  "comex-in-production": "In Production",
  "comex-awaiting-boarding": "Awaiting Boarding",
  "comex-in-transit": "In Transit",
  "comex-registered1": "Registered",
  "comex-completed1": "Completed",
  "comex-canceled": "Canceled",
  "comex-save-step": "Partially Save",
  "comex-budget-rate2": "Budget Rate",
  "comex-enter": "Enter...",
  "comex-save-data-confirmation": "Do you want to save the data filled in so far? You will be able to continue filling it out later.",
  "comex-save-partial-form": "Save Partial Form",
  "comex-mandatory-fields-needs-to-be-filled": "Please fill in all required fields of the negotiation and formalization",
  "comex-mandatory-fields-financial-execution": "Please fill in all mandatory fields of the financial execution",
  "comex-required-fields-letter-of-credit": "Please fill in all required fields of the LC (Letter of Credit)",
  "comex-partially-saved-successfully": "Partially saved successfully",
  "comex-real-value1": "Real value",
  "comex-load-readiness": "Load Readiness",
  "comex-data-loss-warning1": "All entered data will be lost if you have not partially saved it.",
  "comex-inform-currency": "Inform the Currency",
  "comex-aprazo": "On Time",
  "comex-at-sight": "At Sight",
  "comex-load-forecast1": "Load Forecast",
  "comex-payment-date": "Payment Date",
  "comex-payment-bank": "Payment Bank",
  "comex-add-payment": "Add Payment",
  "comex-payment-installment": "Payment installment",
  "comex-confirm-deletion": "Confirm Deletion",
  "comex-operation-confirm-delete": "Upon confirmation, this operation will be permanently deleted. Do you wish to proceed?",
  "comex-operation-deleted-successfully": "Operation deleted successfully",
  "comex-negotiation": "Negotiation",
  "comex-delete1": "Delete",
  "comex-error-deleting-operation": "Error Deleting Operation",
  "comex-download-attachment": "Download Attachment",
  "comex-invoice": "Invoice",
  "comex-ref-trading": "Ref. Trading",
  "comex-early": "anticipated",
  "comex-expiration-date": "Expiration Date",
  "comex-attention": "Attention",
  "comex-negotiation-data-required": "Negotiation data is required",
  "comex-negotiation-attachments": "Negotiation attachments",
  "comex-bank-reference": "",
  "comex-bank-reference1": "Bank Reference",
  "comex-purchase-order": "Purchase Order (PO)",
  "comex-total-value": "Total Value",
  "comex-status-parcela": "Installment Status",
  "comex-average-payment-term": "Average payment term",
  "comex-comment": "Comment",
  "comex-order-date": "Order Date",
  "comex-container-quantity": "Quantity of Containers",
  "comex-release-date": "Release date",
  "comex-release-time": "Release time",
  "comex-annual-cost1": "Annual cost",
  "comex-flat-cost": "Flat Cost",
  "comex-are-you-sure-you-want-to-exit": "Are you sure you want to exit?",
  "comex-flat-opening-commission-rate": "Flat Opening Commission Rate",
  "comex-opening-commission-rate-per-year": "Opening Commission Rate per Year",
  "comex-comex-operation": "Comex operation",
  "comex-no-comex-operation-found": "No comex operation found",
  "comex-product-value": "Product value",
  "comex-bus-station": "Bus station",
  "comex-aereo": "Airborne",
  "comex-maritime-lcl": "Maritime LCL",
  "comex-maritimo-fcl": "Maritime FCL",
  "control-currency-control": "Currency control",
  "control-official-exchange-rate": "Official Exchange Rate",
  "control-exchange-control": "Exchange Control",
  "control-exchange-rates": "Exchange Rates",
  "control-select-coins": "Select Coins",
  "control-recorded-operations": "Recorded Operations",
  "control-no-registered-operations": "No Registered Operations",
  "control-currency-registration": "Currency Registration",
  "control-bank-ag-and-company-account": "Bank, AG and company account",
  "control-operation-date": "Operation date",
  "control-operation-type2": "Type of operation",
  "control-foreign-payer-receiver-bank": "Foreign payer/receiver bank",
  "control-national-payer-receiver-bank": "National payer/receiver bank",
  "control-payer-recipient-country-abroad": "Payer/recipient country abroad",
  "control-exchange-closed": "exchange closed",
  "control-delivery-date-of-exchange": "Delivery date of the exchange",
  "control-foreign-currency-amount": "Amount of foreign currency",
  "control-exchange-edited-successfully": "Exchange edited successfully!",
  "control-exchange-registered-successfully": "Exchange registered successfully!",
  "control-file-deleted-successfully": "File deleted successfully!",
  "control-operation-successfully-deleted": "Operation deleted successfully!",
  "control-remove-exchange-operation": "Remove Exchange Operation",
  "control-confirm-delete-operation": "Are you sure you want to delete this operation?",
  "control-data-operation": "Operation Date",
  "control-foreign-currency-value1": "Value in Foreign Currency",
  "control-valor-me": "Value M.E.",
  "control-exchange-closed1": "Exchange Closed",
  "control-exchange-rate-closed": "Exchange Rate Closed",
  "control-converted-value": "Converted Value",
  "control-converted-value-in-national-currency": "Converted Value in National Currency",
  "control-total-in-national-currency": "Total in National Currency",
  "control-delivery-date-currency": "Delivery Date Currency",
  "control-delivery-date-of-exchange1": "Delivery Date of Exchange",
  "control-foreign-bank": "Foreign Bank",
  "control-payer-or-receiver-bank-abroad": "Payer or Receiver Bank Abroad",
  "control-payer-or-receiver-in-foreign-country": "Payer or Receiver in Foreign Country",
  "control-operation-type3": "Operation Type",
  "control-beneficiary": "Beneficiary",
  "control-installment1": "Installment",
  "control-loan-number-contract": "Loan Number (contract)",
  "control-no-loan-found": "No loan found",
  "control-no-installment-found": "No installment found",
  "costs-actions": "Actions",
  "costs-biological-asset": "Biological Asset",
  "costs-guarantee": "Guarantee",
  "costs-guarantees": "Guarantees",
  "costs-checks": "Checks",
  "costs-customer-contract": "Customer Contract",
  "costs-duplicates": "Duplicates",
  "costs-financial-applications": "Financial Applications",
  "costs-equipment": "Equipment",
  "costs-bank-guarantee": "Bank Guarantee",
  "costs-receivables-flow": "Receivables Flow",
  "costs-real-estate": "Real Estate",
  "costs-raw-material": "Raw Material",
  "costs-promissory-note": "Promissory Note",
  "costs-credit-card-receivables": "Credit Card Receivables",
  "costs-lease-guarantee": "Lease Guarantee",
  "costs-surety-bond": "Surety Bond",
  "costs-vehicles": "Vehicles",
  "costs-inventory": "Inventory",
  "costs-warrant": "Warrant",
  "costs-others": "Others",
  "costs-remove-warranty": "Remove warranty",
  "costs-confirm-delete-warranty": "Are you sure you want to delete this warranty?",
  "costs-guarantee-excluded-successfully": "Guarantee excluded successfully",
  "costs-warranty-management": "Warranty management",
  "costs-register-warranty": "Register Warranty",
  "costs-no-registered-warranty": "No Registered Warranty",
  "costs-all-warranties": "All Warranties",
  "costs-list-of-guarantees": "List of guarantees",
  "costs-add-warranties": "Add Warranties",
  "costs-reference-name": "Reference name",
  "costs-add-name-to-guarantee": "Add a name to the guarantee",
  "costs-last-evaluation-date": "Date of the last evaluation",
  "costs-guarantee-edited-successfully": "Guarantee edited successfully!",
  "costs-guarantee-registered-successfully": "Guarantee registered successfully!",
  "costs-number-of-installments1": "",
  "costs-number-of-instalments": "Number of Instalments",
  "costs-ace": "Advance on Delivered Exchange Contracts",
  "costs-acc": "Advance on Exchange Contract",
  "costs-bndes": "National Bank for Economic and Social Development",
  "costs-working-capital": "Working Capital",
  "costs-manufacturer-financing": "Manufacturer CDC",
  "costs-direct-consumer-credit": "Direct Consumer Credit",
  "costs-bank-credit-note": "Bank Credit Note",
  "costs-export-credit-ballot": "Export Credit Note",
  "costs-finimp": "Financing for Importation",
  "costs-leasing": "Leasing",
  "costs-loan": "Loan",
  "costs-export-credit-note": "Export Credit Note",
  "costs-foreign-repass": "Foreign Repass",
  "costs-export-prepayment": "Export Prepayment",
  "costs-commercial-note": "Commercial Note",
  "costs-fixed-rate": "Fixed Rate",
  "costs-percent-of-libor": "% LIBOR",
  "costs-percent-of-sofr": "% SOFR",
  "costs-percent-of-euribor": "% EURIBOR",
  "costs-liborplus-spread": "LIBOR + Spread",
  "costs-sofrplus-spread": "SOFR + Spread",
  "costs-euriborplus-spread": "EURIBOR + Spread",
  "costs-tjlp": "TJLP",
  "costs-tlp": "TLP",
  "costs-tfb": "TFB",
  "costs-selic-plus-rate": "Selic + Rate",
  "costs-pre": "PRE",
  "costs-cdiplus-rate": "CDI + Rate",
  "costs-percent-of-cdi": "% CDI",
  "costs-percent-of-selic": "% Selic",
  "costs-loans": "Loans",
  "costs-currency-variation": "Currency Variation (CV)",
  "costs-loan-details": "Loan Details",
  "costs-settle-instalment": "Settle Instalment",
  "costs-manage-derivatives": "Manage Derivatives",
  "costs-link-derivative": "Link Derivative",
  "costs-revert": "Revert",
  "costs-cannot-reverse-unsettled-installment": "It is not possible to reverse an installment that is not settled",
  "costs-revert-payment": "Revert Payment",
  "costs-reverse-payment-installment": "Do you want to reverse the payment of the installment?",
  "costs-payment-reverted-successfully": "Payment reverted successfully!",
  "costs-unable-to-reverse-unpaid-instalment": "It is not possible to reverse an instalment that is not paid.",
  "costs-no-data-available": "No data available",
  "costs-no-results-found": "No results found",
  "costs-entries": "Entries",
  "costs-last-payment": "Last payment",
  "costs-total-installments": "Total of installments",
  "costs-loan-types": "Types of loan",
  "costs-credit-value": "Credit value",
  "costs-credit-in-national-currency": "Credit in national currency",
  "costs-outstanding-balance-in-local-currency": "Outstanding balance in local currency",
  "costs-last-installment-due-date-start": "Due date of the last installment (start)",
  "costs-last-installment-due-date-end": "Last installment due date (end)",
  "costs-working-capital1": "Working Capital",
  "derivatives-settled-transactions": "Settled Transactions",
  "derivatives-hedge-position": "Hedge Position",
  "derivatives-report-error-title": "Error generating report, please try again.",
  "derivatives-report-error-description": "If the error persists, please contact support.",
  "derivatives-report-error-btn-suport": "Support",
  "derivatives-report-error-btn-try-again": "Try Again",
  "derivatives-report-success-title": "Report generated successfully!",
  "derivatives-report-success-description": "Your report has been automatically downloaded. Find it in the Downloads folder or the chosen location.",
  "derivatives-budget-rate": "",
  "derivatives-exchange-rate-exposure": "",
  "derivatives-exposure-currency": "",
  "document-padronization-document-padronization": "Standardization of Documents",
  "document-padronization-notional1": "Notional",
  "effective-exchange-rate-select-at-least-one-request": "Select at least one request to view the information",
  "effective-exchange-rate-currency-effectiveness": "Effective Exchange Rate",
  "effective-exchange-rate-hedges": "Hedges",
  "effective-exchange-rate-currency-closure": "Currency Closure",
  "effective-exchange-rate-cash-flow1": "Cash flow",
  "effective-exchange-rate-hedge-order": "Hedge Order",
  "effective-exchange-rate-deadline-days1": "Deadline (Days)",
  "effective-exchange-rate-price-ndf1": "Price (NDF)",
  "effective-exchange-rate-cap-do-ndf": "CAP of the NDF",
  "effective-exchange-rate-ptax-reversal": "PTAX/Reversal",
  "effective-exchange-rate-exchange-rate-effective-calculated": "Effective Exchange Rate (Calculated)",
  "effective-exchange-rate-hedge-effective-exchange": "Effective Exchange of Hedge",
  "effective-exchange-rate-exchange2": "Exchange",
  "effective-exchange-rate-priced-exchange": "Priced Exchange",
  "effective-exchange-rate-cash-flow2": "Cash Flow",
  "effective-exchange-rate-effective-date": "Effective Date",
  "effective-exchange-rate-value-me": "ME Value",
  "effective-exchange-rate-order-event": "Order Event",
  "effective-exchange-rate-data-contract": "Data Contract.",
  "effective-exchange-rate-settlement-date1": "Settlement date",
  "effective-exchange-rate-exchange-budget": "Exchange Budget",
  "effective-exchange-rate-accumulated-balance": "Accumulated Balance",
  "general-open": "Open",
  "general-opened": "Opened",
  "general-close": "Close",
  "general-closed": "Closed",
  "general-submit-file": "Submit File",
  "general-move": "Move",
  "general-rename": "Rename",
  "general-upload-files": "pload files",
  "general-new-folder": "New folder",
  "general-not-informed": "Not informed",
  "general-insertion-date": "Insertion date",
  "general-name": "Name",
  "general-documents": "Documents",
  "general-general-prasentation": "General Presentation",
  "general-folder": "Folder",
  "general-folders": "Folders",
  "general-output": "Output",
  "general-report-type": "Report type",
  "general-client": "Client",
  "general-insert": "Insert",
  "general-save": "Save",
  "general-saving": "Saving...",
  "general-cancel": "Cancel",
  "general-send": "Send",
  "general-delete": "Delete",
  "general-update": "Update",
  "general-updated": "Updated",
  "general-loading": "Loading",
  "general-network-error": "Network Error",
  "general-network-error-message": "Please check your connection or if the server is running.",
  "general-request-error": "Request Processing Error",
  "general-search": "Search",
  "general-dashboard": "Dashboard",
  "general-administration": "Administration",
  "general-settings": "Settings",
  "general-logs": "Logs",
  "general-monitoring": "Monitoring",
  "general-users": "Users",
  "general-duplicate": "Duplicate",
  "general-register": "Register",
  "general-groups": "Groups",
  "general-portuguese-br": "Portuguese-BR",
  "general-spanish-es": "Spanish-ES",
  "general-english-us": "English-US",
  "general-active": "Active",
  "general-yes": "Yes",
  "general-no": "No",
  "general-type-observation": "Type observation",
  "general-observation": "Observation",
  "general-observations": "Observations",
  "general-corporate-reason": "Corporate Reason",
  "general-cnpj": "CNPJ",
  "general-fantasy-n": "Fantasy.N",
  "general-fantasy-name": "Trade Name",
  "general-optional": "Optional",
  "general-institution": "Institution",
  "general-surname": "Surname",
  "general-user-or-email": "User or email",
  "general-filter": "Filter",
  "general-filters": "Filters",
  "general-clear": "To clear",
  "general-apply": "To apply",
  "general-next": "Next",
  "general-confirm": "Confirm",
  "general-form-invalid": "Form invalid",
  "general-user": "User",
  "general-month": "Month",
  "general-year": "Year",
  "general-day": "Day",
  "general-actual": "Actual",
  "general-shopping": "Shopping",
  "general-sofr": "SOFR",
  "general-derivatives-index": "Derivative Index",
  "general-cost-savings-comparison": "Cost savings comparison",
  "general-bankability-score": "Bankability Score",
  "general-good-credit-score": "Good Credit Score",
  "general-economic-calendar": "Economic Calendar",
  "general-available-credit-contracted": "Available credit contracted",
  "general-cdi": "CDI",
  "general-ipca": "IPCA",
  "general-time": "Time",
  "general-event": "Event",
  "general-real": "Real",
  "general-previous": "Previous",
  "general-forecast": "Forecast",
  "general-address": "Address",
  "general-site": "Site",
  "general-your-browser-does-not-support-video": "Your browser does not support the video",
  "general-required-field": "Required field",
  "general-ok": "Ok",
  "general-file": "File",
  "general-files": "Files",
  "general-size": "Size",
  "general-to-go-back": "Go back",
  "general-category": "Category",
  "general-review": "Review",
  "general-document": "Document",
  "general-reject": "Reject",
  "general-approve": "Approve",
  "general-download": "Download",
  "general-all": "All",
  "general-no-user-registered-for-selected-company": "No user registered for the selected company",
  "general-write-adescription": "Write a description",
  "general-write-aname": "Write a name",
  "general-description": "Description",
  "general-finalize": "Finalize",
  "general-everything-is-fine": "Everything is fine!",
  "general-oops-something-went-wrong": "Oops, something went wrong!",
  "general-actions": "Actions",
  "general-go-back": "back",
  "general-shrink-expand": "Shrink/Expand",
  "general-expand1": "Expand",
  "general-shrink": "shrink",
  "general-select1": "Select",
  "general-uncheck": "uncheck",
  "general-export1": "Export",
  "general-operations-exported-successfully": "Operations exported successfully!",
  "general-edit": "Edit",
  "general-add-contact": "Add Contact",
  "general-contact-name": "Contact Name",
  "general-telephone": "Telephone",
  "general-job-title": "Job Title",
  "general-email": "Email",
  "general-description1": "Description",
  "general-contacts": "Contacts",
  "general-data-loss-warning": "All entered data will be lost.",
  "general-global-limit": "Global Limit",
  "general-add": "Add",
  "general-information-edited-successfully": "Information edited successfully!",
  "general-company": "Company",
  "general-limit-type": "Limit type",
  "general-value": "Value",
  "general-share": "Share",
  "general-list": "list",
  "general-to-see": "View",
  "general-create": "Create",
  "general-period": "Period",
  "general-select-month": "Select the month",
  "general-select-year": "Select the year",
  "general-expiration-period": "Expiration Period",
  "general-initial-data": "Initial Data",
  "general-select-start-date": "Select the start date",
  "general-final-date": "Final Date",
  "general-select-end-date": "Select the end date",
  "general-operation-type1": "Operation Type",
  "general-select-operation-type": "Select the type of operation",
  "general-output-format": "Output Format",
  "general-generate-report": "Generate Report",
  "general-select-customer": "Select the customer",
  "general-cog-ai": "Cog AI",
  "general-remove": "Remove",
  "general-reference": "Reference",
  "general-asset-type": "Asset Type",
  "general-asset-description": "Asset Description",
  "general-assessed-value": "Assessed Value",
  "general-evaluation-date": "Evaluation Date",
  "general-value-of-guarantee": "Value of Guarantee",
  "general-warranty-status": "Warranty Status",
  "general-percentage-compromised": "% Compromised",
  "general-control-module": "Control",
  "general-performance-module": "Performance",
  "general-negotiation-moduke": "Negotiation",
  "general-remove-uploaded-file": "Remove uploaded file",
  "general-confirm-file-removal": "Are you sure you want to remove the submitted file?",
  "general-file-removed-successfully": "File removed successfully!",
  "general-social-contract-and-contractual-amendments-of-the-holding": "Social contract and contractual amendments of the holding",
  "general-holding-financial-statements-last3-years": "Holding financial statements (last 3 years)",
  "general-de": "of",
  "general-files1": "file(s)",
  "general-file-limit-reached": "File limit reached",
  "general-max-files-limit": "You can add a maximum of {maxFiles} files.",
  "general-registration-date": "Registration Date",
  "general-zip-code": "Postal Code",
  "general-city": "City",
  "general-uf": "UF",
  "general-qualification": "Qualification",
  "general-country": "country",
  "general-legal-representative": "Legal Representative",
  "general-qsa-receita-federal": "QSA - Federal Revenue",
  "general-legal-representative-qualification": "Qualification of the Legal Representative",
  "general-no-records-found": "No records found",
  "general-sector1": "Sector",
  "general-site1": "Site",
  "general-remove-operation": "Remove operation",
  "general-invalid-cnpj": "Invalid CNPJ",
  "general-email-sent-successfully": "Email sent successfully!",
  "general-registration-data": "Registration Data",
  "general-derivative": "Derivative",
  "general-view-all": "View all",
  "general-view-operation": "View Operation",
  "general-events-in": "Events in",
  "general-import-operations": "Import operations",
  "general-extracting-operations": "Extracting operations...",
  "general-send-file-or-text-to-extract-operations": "Send a file or text to extract the operations",
  "general-create-with-cog-ai": "Create with COG AI",
  "general-drag-image-here-or-paste-from-clipboard": "Drag an image here or paste from the clipboard",
  "general-start-from-image": "Start from Image",
  "general-select-image": "Select Image",
  "general-preview": "Preview",
  "general-from-text": "From text",
  "general-operations-imported-successfully": "operations were imported successfully",
  "general-operations-not-imported-due-to-different-currencies": "operations were not imported because they are of different currencies",
  "general-current-demand-currency": "of the current demand currency",
  "general-selected-columns": "selected columns",
  "general-select-columns": "Select the columns",
  "general-columns1": "Columns",
  "general-parity": "parity",
  "general-operation-id": "Operation ID",
  "general-cap1": "cap",
  "general-volume": "Volume",
  "general-future-value": "Future Value",
  "general-select-bank-before-continue": "Select a bank before continuing.",
  "general-in-thousands": "In Thousands",
  "general-create-operations-with-cog-ai": "Create operations with Cog AI",
  "general-annual-hedge-cost-percentage": "Annual hedge cost %",
  "general-preparing-download": "Preparing Download",
  "general-downloading-file": "Downloading file",
  "general-error-downloading": "Error downloading",
  "general-compressing-files": "Compressing files",
  "general-download-error": "Error in the download process",
  "general-error-generating-pdf": "An error occurred while generating the PDF",
  "general-generating-pdf1": "Generating PDF...",
  "general-reports": "Reports",
  "general-generating-excel": "Generating Excel...",
  "general-select-all": "Select all",
  "general-manage": "Manage",
  "general-click-here-to-register": "Click here to register",
  "general-current-time": "Current Time",
  "general-expiration-calendars": "Expiration Calendars",
  "general-register1": "Register",
  "general-demand1": "demand",
  "general-purpose": "Purpose",
  "general-status1": "Status",
  "general-currency1": "Currency",
  "general-flow2": "Flow",
  "general-supplier1": "Supplier",
  "general-attach-contract": "Attach Contract",
  "general-agency-and-account": "Agency and Account",
  "general-additional-costs1": "Additional Costs",
  "general-total-convertido": "Total Converted",
  "general-bank-payer": "Payer Bank",
  "general-country1": "Country",
  "general-displaying": "Displaying",
  "general-no-items-found": "No items found",
  "general-data-contracting": "Contracting Date",
  "general-value2": "Value",
  "general-in-development": "",
  "general-feature-not-available": "",
  "general-select-company-to-start": "",
  "general-start-modeling-select-company": "",
  "general-launch-instalments": "",
  "general-attention1": "Attention!",
  "general-details1": "Details",
  "general-demand-link-comex-loan": "This demand needs to be linked to a Comex or Loan",
  "general-responsible-user": "Responsible User",
  "general-priority": "Priority",
  "general-expected-final-date": "Expected final date",
  "general-priority1": "Priority",
  "general-add-comment": "Add Comment",
  "general-delete-comment": "Delete comment",
  "general-expected-end-date": "Expected end date",
  "general-add-task": "Add task",
  "general-document-deleted-successfully": "Document deleted successfully",
  "general-error-deleting-document": "Error deleting document",
  "general-operation-date-start": "Operation date (start)",
  "general-operation-date-end": "Operation date (end)",
  "general-all-a": "all",
  "general-all-companies": "All companies",
  "management-insertion-date": "Insertion Date",
  "management-reports": "Reports",
  "management-home": "Home",
  "management-onboarding": "Onboarding",
  "management-back-office": "Back Office",
  "management-document-analysis": "Document Analysis",
  "management-data-room": "Data Room",
  "management-types-of-credit-limit": "Types of credit limit",
  "management-billing": "Billing",
  "management-loans": "Loans",
  "management-no-loans-registered": "No loan operations registered",
  "management-cost": "Cost",
  "management-demands": "Demands",
  "management-hedge-accounting": "Hedge Accounting",
  "management-mark-to-market": "Mark to Market",
  "management-risk-management": "Risk Management",
  "management-indebtedness": "Indebtedness",
  "management-collateral-registry": "Collateral Registry",
  "management-credit-demand": "Credit Demand",
  "management-debt-registry": "Debt Registry",
  "management-debt-report": "Debt Report",
  "management-debt-flow": "Debt Flow",
  "management-import-control": "Import control",
  "management-credit": "Credit Analysis",
  "management-economic-analysis": "Economic Analysis",
  "management-financial-statements": "Financial Statements",
  "management-cash-flow-statement": "Cash Flow Statement",
  "management-income-statement": "Income Statement",
  "management-balance-sheet": "Balance Sheet",
  "management-dashboard": "Dashboard",
  "management-assumptions": "Assumptions",
  "management-projects": "Projects",
  "management-scope": "Scope",
  "management-physical-financial-schedule": "Physical Financial Schedule",
  "management-cash-flow": "Cash Flow",
  "management-financial-modeling": "Financial Modeling",
  "management-business-case": "Business Case",
  "management-project-finance": "Project Finance",
  "management-market": "Market",
  "management-credit-operations-pipeline": "Credit Operations Pipeline",
  "management-bank-accounts": "Bank Accounts",
  "management-financial-institution": "Financial Institution",
  "management-financial-institutions": "Financial Institutions",
  "management-management": "Management",
  "management-id": "Id",
  "management-name": "Name",
  "management-compensation-code": "Comp. Code",
  "management-description": "Description",
  "management-associates": "Associates",
  "management-users": "Users",
  "management-user": "User",
  "management-status": "Status",
  "management-actions": "Actions",
  "management-clients": "Clients",
  "management-data": "Data",
  "management-days": "Days",
  "management-financial-institution-created-successfully": "Management financial institution created successfully",
  "management-financial-institution-updated-successfully": "Management financial institution updated successfully",
  "management-financial-institution-deleted-successfully": "Management financial institution removed successfully",
  "management-no-financial-institutions-registered": "No financial institutions registered",
  "management-attachment-type": "Attachment type",
  "management-attachment-types": "Attachment types",
  "management-no-attachment-types-registered": "No attachment types registered",
  "management-add-attachment-type": "Add attachment type",
  "management-attachment-type-created-successfully": "Attachment type created successfully",
  "management-attachment-type-updated-successfully": "Attachment type updated successfully",
  "management-attachment-type-deleted-successfully": "Attachment type removed successfully",
  "management-tenant": "Tenant",
  "management-tenants": "Tenants",
  "management-no-tenants-registered": "No tenants registered",
  "management-add-tenant": "Add",
  "management-tenant-created-successfully": "Tenant created successfully",
  "management-tenant-updated-successfully": "Tenant updated successfully",
  "management-tenant-deleted-successfully": "Tenant removed successfully",
  "management-financial-institution-title-delete-confirmation": "Are you sure you want to delete this financial institution?",
  "management-financial-institution-description-delete-confirmation": "The financial institution will lose all access to the system.",
  "management-attachment-type-title-delete-confirmation": "Are you sure you want to delete this type of attachment?",
  "management-attachment-type-description-delete-confirmation": "The attachment type will be removed from the system.",
  "management-tenant-title-delete-confirmation": "Are you sure you want to delete this tenant?",
  "management-tenant-description-delete-confirmation": "The tenant will be removed from the system.",
  "management-company": "Company",
  "management-companys": "Companys",
  "management-no-companys-registered": "No companys registered",
  "management-add-company": "Add company",
  "management-company-created-successfully": "Company created successfully",
  "management-company-updated-successfully": "Company updated successfully",
  "management-company-deleted-successfully": "Company removed successfully",
  "management-company-delete-confirmation-title": "Are you sure you want to delete this company?",
  "management-company-delete-confirmation-description": "The company will be removed from the system.",
  "management-company-all-companys": "All companys",
  "management-ndf-calculator": "NDF Calculator",
  "management-ndf-new-demand": "New demand",
  "management-ndf-export-to-excel": "Export to Excel",
  "management-ndf-simulations": "Simulations",
  "management-ndf-listed": "Listed",
  "management-ndf-contractors": "Contractors",
  "management-ndf-currency": "Currency",
  "management-ndf-demands": "Demands",
  "management-ndf-creation": "Creation",
  "management-derivatives": "Derivatives",
  "management-ndf-scenario": "Scenario",
  "management-ndf-scenarios": "Scenarios",
  "management-ndf-new-scenario": "New scenario",
  "management-ndf-operation": "Operation",
  "management-ndf-operation-type": "Type of operation",
  "management-ndf-hired-operation": "Hired operations",
  "management-ndf-value": "Value",
  "management-ndf-due-date": "Due Date",
  "management-ndf-due-date-initial": "Initial Due Date",
  "management-ndf-due-date-final": "Final Due Date",
  "management-ndf-reference": "Reference",
  "management-ndf-remarks": "Remarks",
  "management-ndf-import": "Import",
  "management-ndf-export": "Export",
  "management-ndf-loan": "Loan",
  "management-ndf-pin-unpin": "Pin/Unpin",
  "management-ndf-add-trading-note": "Add Trading Note",
  "management-ndf-demand-management": "Demand management",
  "management-ndf-operation-management": "Operation management",
  "management-ndf-quote": "Quote",
  "management-ndf-quotation": "Cotação",
  "management-ndf-successfully-contracted": "Successfully contracted",
  "management-ndf-date-operations": "Operation date",
  "management-no-demand-registered": "No demand registered",
  "management-ndf-deadline-days": "Deadline (days)",
  "management-ndf-calendar-days": "Calendar days",
  "management-ndf-working-days": "Working days",
  "management-ndf-exchange": "Exchange",
  "management-ndf-rate": "Rate",
  "management-ndf-to-hire": "To hire",
  "management-ndf-demand": "Demand",
  "management-ndf-add-simulation": "Add simulation",
  "management-ndf-you-have": "You have",
  "management-ndf-bank": "Bank",
  "management-ndf-date-of-operation": "Date of operation",
  "management-ndf-notional": "Notional",
  "management-ndf-forward": "Forward",
  "management-ndf-forward-brl-me": "Forward (BRL/ME)",
  "management-ndf-volume-protected-up-to-cap": "Volume protected up to limiter",
  "management-ndf-last-date-ptax-passed-cap": "Last date PTAX passed CAP",
  "management-ndf-reference-exchange": "Reference exchange",
  "management-ndf-notional-brl-by-reference": "Notional BRL by reference",
  "management-ndf-nominal-cost-brl": "Nominal cost BRL",
  "management-ndf-nominal-cost": "Nominal cost",
  "management-ndf-settlement-fee": "Settlement fee",
  "management-ndf-settlement-spot": "Spot",
  "management-ndf-add-scenario": "Add scenario",
  "management-ndf-simulation": "Simulation",
  "management-ndf-select-the-bank": "Select the bank",
  "management-ndf-insert-date": "Inset date",
  "management-ndf-enter-due-date": "Enter due date",
  "management-ndf-insert-days": "Inset days",
  "management-ndf-insert-notional": "Insert notional",
  "management-ndf-insert-forward": "Insert forward",
  "management-ndf-insert-cap": "Insert CAP",
  "management-ndf-to-compare": "To compare",
  "management-ndf-cap": "CAP",
  "management-ndf-notional-flat": "Notional (flat)",
  "management-ndf-notional-aa": "Notional (a.a)",
  "management-ndf-create-demand": "Create demand",
  "management-ndf-create-simulation": "Create simulation",
  "management-ndf-simulate": "Simulate",
  "management-ndf-demand-is-invalid": "Demand is invalid",
  "management-ndf-simulation-is-invalid": "Simulation is invalid",
  "management-ndf-derivative-information": "Derivative information",
  "management-ndf-deadline": "Deadline",
  "management-ndf-notion-me": "Notion (ME)",
  "management-ndf-new-operation": "New operation",
  "management-ndf-no-operation-registred": "No operation registered",
  "management-ndf-derivatives-operations-management": "Derivatives operations management",
  "management-ndf-derivatives-management": "Derivatives management",
  "management-ndf-quote-saved-successfully": "Quote saved successfully!",
  "management-ndf-hire-saved-successfully": "Successfully saved hire!",
  "management-ndf-reference-fees": "Reference Fees",
  "management-ndf-insert-fee": "Insert fee",
  "management-ndf-settle-operation": "Settle Operation",
  "management-ndf-finalize-settlement": "Finalize settlement",
  "management-ndf-duplicate-simulation": "Duplicated simulation",
  "management-ndf-demand-simulation-created-successfully": "Demand simulation created successfully",
  "management-ndf-operations": "Operations",
  "management-ndf-demand-saved-successfully": "Demand saved successfully!",
  "management-ndf-date-and-time": "Date and time",
  "management-ndf-hire-quote": "Hire quote",
  "management-ndf-settle-contract": "Settle contract",
  "management-operation-title-delete-confirmation": "Are you sure you want to delete this operation?",
  "management-ndf-settlement-information": "Settement information",
  "management-ndf-add-settlement-note": "Add settlement note",
  "management-ndf-add-settlement-reversed": "Save Revert",
  "management-ndf-add-settlement-reversed-title": "Click to save the operation reversal. This reversal generates a copy of the current operation without affecting it.",
  "management-ndf-early-reversal-liquidation-success": "Early reversal successfully settled",
  "management-ndf-early-reversal-liquidation-error": "Error settling the early reversal",
  "management-ndf-form-invalid": "Invalid form",
  "management-ndf-please-check-fields": "Please check all required fields",
  "management-ndf-no-response-received": "No response received from the server",
  "management-ndf-settlement-date": "Settlement date",
  "management-ndf-notional-settlement": "Notional settlement",
  "management-ndf-irrf": "IRRF",
  "management-ndf-irto-pay": "IR to pay",
  "management-ndf-net-adjustment": "Net adjustment",
  "management-ndf-gross-adjustment": "Gross adjustment",
  "management-ndf-operation-successfully-selled": "Operation successfully selled",
  "management-ndf-simulated": "Simulated",
  "management-ndf-quoted": "Quoted",
  "management-ndf-hired": "Hired",
  "management-ndf-demand-title-delete-confirmation": "Are you sure you want to delete this demand?",
  "management-ndf-demand-deleted-successfully": "Delete demand successfully",
  "management-ndf-full-on-maturity": "Full upon expiration",
  "management-ndf-before-maturity": "Full before maturity",
  "management-ndf-partial": "Partial",
  "management-ndf-settlement-notional": "Notional settlement",
  "management-error-loading-tenants": "Error loading tenants",
  "management-error-loading-tenant": "Error loading tenant",
  "management-error-removing-tenant": "Error removing tenant",
  "management-error-creating-tenant": "Error creating tenant",
  "management-error-updating-tenant": "Error updating tenant",
  "management-error-loading-financial-institutions": "Error loading financial institutions",
  "management-error-loading-financial-institution": "Error loading financial institution",
  "management-error-removing-financial-institution": "Error removing financial institution",
  "management-error-creating-financial-institution": "Error creating financial institution",
  "management-error-updating-financial-institution": "Error updating financial institution",
  "management-error-loading-companys": "Error loading companys",
  "management-error-loading-company": "Error loading company",
  "management-error-removing-company": "Error removing company",
  "management-error-creating-company": "Error creating company",
  "management-error-updating-company": "Error updating company",
  "management-error-loading-attachment-types": "Error loading attachment types",
  "management-error-loading-attachment-type": "Error loading attachment type",
  "management-error-removing-attachment-type": "Error removing attachment type",
  "management-attachment-type-removed-successfully": "Attachment type removed successfully",
  "management-error-creating-attachment-type": "Error creating attachment type",
  "management-error-updating-attachment-type": "Error updating attachment type",
  "management-error-loading-operations": "Error loading operations",
  "management-error-loading-operation": "Error loading operation",
  "management-error-removing-operation": "Error removing operation",
  "management-operation-removed-successfully": "Operation removed successfully",
  "management-error-creating-operation": "Error",
  "management-operation-created-successfully": "Operation created successfully",
  "management-error-updating-operation": "Error updating operation",
  "management-operation-updated-successfully": "Operation updated successfully",
  "management-error-loading-operations-status-count": "Error loading operations status count",
  "management-error-loading-previous-day-ptax": "Error loading previous day PTAX",
  "management-error-loading-internacional-currencies": "Error loading internacional currencies",
  "management-error-loading-operation-max-value": "Error loading operation max value",
  "management-error-loading-demands": "Error loading demands",
  "management-error-loading-demand": "Error loading demand",
  "management-error-removing-demand": "Error removing demand",
  "management-error-creating-demand": "Error creating demand",
  "management-demand-created-successfully": "Demand created successfully",
  "management-demand-simulation-created-successfully": "Demand simulation created successfully",
  "management-error-updating-demand": "Error updating demand",
  "management-error-loading-demand-max-value": "Error loading demand max value",
  "management-error-creating-demand-simulation": "Error creating demand simulation",
  "management-error-calculating-due-date": "Error calculating due date",
  "management-error-loading-highest-twelve-month-above-cap": "Error loading highest twelve month above cap",
  "management-ndf-operation-status": "Operation status",
  "management-ndf-financial-status": "Financial status",
  "management-ndf-composition": "Composition",
  "management-ndf-open": "Open",
  "management-ndf-settled": "Settled",
  "management-ndf-settled-reversed": "Reversal",
  "management-ndf-full": "Full",
  "management-ndf-quotation-date-hour-confirmation": "Are you sure you want to place the quote on the date/time",
  "management-ndf-hire-date-hour-confirmation": "Are you sure you want to place the hire on the date/time",
  "management-ndf-time": "Time",
  "management-ndf-origem": "Origin",
  "management-ndf-financial-operator": "Financial operator (Bank)",
  "management-ndf-revert-to-quoted": "Revert to quoted",
  "management-ndf-revert-liquidated-to-open": "Revert liquidated to open",
  "management-ndf-operation-reverted-successfully": "Operation reverted successfully",
  "management-ndf-error-reverting-operation": "Error reverting operation",
  "management-ndf-operation-title-revert-liquidation-confirmation": "Are you sure you want to revert the liquidation of this operation?",
  "management-ndf-settlement-scenarios": "Settlement scenarios",
  "management-ndf-settlement-exchange": "Settlement exchange",
  "management-ndf-cost-per-year-per-scenario": "Cost per year per scenario",
  "management-ndf-cost-per-year-scenario-reference-exchange-rate": "Cost per year per Scenarios at the Reference Exchange Rate",
  "management-ndf-annual-cost": "Annual cost",
  "management-ndf-settlement-rate": "Settlement rate",
  "management-ndf-withholding-tax": "Withholding tax",
  "management-ndf-income-tax-payable": "Income tax payable",
  "management-see-operations": "Operations",
  "management-add-credit-limit-type": "Add Credit Limit Type",
  "management-no-credit-limit-type-founded": "No credit limit registered",
  "management-document-analysis-queue": "Document Analysis Queue",
  "management-error-loading-files": "Error loading files",
  "management-company-name": "Company name",
  "management-documents-for-analysis": "Documents for analysis",
  "management-upload-date": "Upload date",
  "management-finalize-analysis": "Finalize analysis",
  "management-save-without-approving-or-rejecting": "Save without approving or rejecting",
  "management-under-review": "Under review",
  "management-are-you-sure-you-want-to-reject": "Are you sure you want to reject?",
  "management-this-action-cannot-be-undone": "This action cannot be undone",
  "management-are-you-sure-you-want-to-finish": "Are you sure you want to finish?",
  "management-the-review-will-be-saved-nsent-to-customer": "La reseña se guardará y se enviará al cliente",
  "management-there-are-unrated-files": "There are unrated files!",
  "management-check-before-approving": "Check before approving",
  "management-preview-unavailable-download-file": "Preview unavailable. Download the file!",
  "management-document-rejected": "Document rejected",
  "management-document-rejected-successfully": "Document rejected successfully",
  "management-error-rejecting-document": "Error rejecting document",
  "management-document-approved": "Document approved",
  "management-document-approved-successfully": "Document approved successfully",
  "management-error-approving-document": "Error approving document",
  "management-limit-type-registered-successfully": "Limit type registered successfully!",
  "management-credit-limit-deleted-successfully": "credit limit deleted successfully!",
  "management-delete-credit-limit": "Delete credit limit?",
  "management-confirm-delete-credit-limit": "Are you sure you want to delete this credit limit?",
  "management-indicative": "indicative",
  "management-contracted-operations": "With contracted operations",
  "management-contracts-active-and-open": "With contracted and open operations",
  "management-budget-rate1": "Contract Exchange Rate",
  "management-exchange-exhibition": "Exchange Exhibition",
  "management-hedge-position1": "Hedge Position",
  "management-settled-operations": "Settled Operations",
  "management-revert-to-simulated": "Revert to Simulated",
  "management-status-reversion": "Status reversion",
  "management-confirm-reversal-quotation-to-simulated": "Are you sure you want to reverse the quotation and set the status of this operation to Simulated?",
  "management-confirm-reverse-settlement-set-status-open": "Are you sure you want to reverse the settlement and set the status of this operation to 'Open Contract'?",
  "management-confirm-revert-contract-status-quoted": "Are you sure you want to revert the contract and set the status of this operation to Quoted?",
  "management-operation-start-date": "Operation start date",
  "management-operation-end-date": "End date of the operation",
  "management-search-data-receita-federal": "Search data in the Federal Revenue",
  "management-unsaved-operations-warning": "You selected unsaved operations, you need to save the request first.",
  "management-incomplete-fields-warning": "Attention: there are unfilled fields or incomplete operations. Please complete all items before saving.",
  "management-remove-operation-save-demand": "To remove an operation, save the request first.",
  "management-demand-type": "type",
  "management-confirm-remove-operation": "Are you sure you want to remove this operation from the demand?",
  "management-operations-removal-security": "For security, only operations with the status 'Simulated' can be removed.",
  "management-reject-document": "Reject Document",
  "management-approve-document": "Approve Document",
  "management-approve-document-confirmation": "Are you sure you want to approve this document?",
  "management-approve-all-documents": "Approve all",
  "management-approve-all-documents-confirmation": "All pending documents for this company will be approved. Documents already approved or rejected will not be changed, and no email will be sent to the client.",
  "management-approve-all-documents-success": "{{applied}} document(s) approved",
  "management-approve-all-documents-partial": "{{applied}} approved, {{failed}} failed",
  "management-approve-all-documents-none-applied": "No documents were approved",
  "management-approve-all-documents-skipped": "{{skipped}} document(s) unchanged",
  "management-error-sending-email-analysis-results": "Error sending email with the analysis results of the documents",
  "management-document-analysis1": "Document Analysis",
  "management-password-recovery-link": "Password Recovery Link",
  "management-send-email-password-recovery": "Send Password Recovery Email",
  "management-modality": "Modality",
  "management-monthly": "Monthly",
  "management-quarterly": "quarterly",
  "management-cost-consideration-low-strike": "The cost was considered when reaching the low strike. The cost may vary according to exchange rate fluctuations.",
  "management-error-loading-di": "Error loading Di",
  "management-factor-di": "DI factor",
  "management-derivative-management": "Derivative Management",
  "management-derivative-demand-not-found": "It was not possible to find the associated derivative demand.",
  "management-derivative-operation-not-found": "The associated derivative operation could not be found.",
  "management-link-operation-to-loan-or-comex": "It is necessary to link this operation to a Loan or Comex. Make the association before saving the changes.",
  "management-linked-installments": "linked installments",
  "management-linked-installment": "linked installment",
  "management-expiration1": "Expiration",
  "management-link-installments": "Link installments",
  "management-ispb": "ISPB",
  "management-short-name": "Short name",
  "management-display-name": "Display Name",
  "management-network": "Network",
  "management-url": "URL",
  "management-revert-hiring": "Revert hiring",
  "management-market-projection-curves": "Market Projection Curves",
  "market-customer-documents": "Customer documents",
  "market-customer-folders": "Customer-folders",
  "market-contract-folders": "Contract-folders",
  "market-no-folders-found": "No folders found",
  "market-no-company-found": "No company found",
  "market-no-folders-documents-found": "No folders documents found",
  "market-where-do-you-want-to-move": "Where do you want to move",
  "market-folder-created-successfully": "Folder created successfully!",
  "market-error-creating-folder": "Error creating folder!",
  "market-unable-to-create-new-folder": "Unable to create a new folder.",
  "market-file-renamed-successfully": "File renamed successfully!",
  "market-error-renaming-file": "Error renaming file!",
  "market-unable-to-rename-file": "Unable to rename file",
  "market-file-moved-successfully": "File moved successfully!",
  "market-error-moving-file": "Error moving file!",
  "market-unable-to-move-file": "Unable to move file",
  "market-upload-file-successfully": "Upload file successfully",
  "market-error-on-upload-file": "Error on upload file",
  "market-unable-to-upload-file": "Unable to upload file",
  "market-folder-moved-successfully": "Folder moved successfully!",
  "market-folder-renamed-successfully": "Folder renamed successfully!",
  "market-sending-file": "Sending file...",
  "market-create-bank-relationship": "",
  "market-register-bank-relationship": "Register Bank Relationship",
  "market-account-info-and-contacts-linked": "Account information and linked contacts",
  "market-account-number": "Account Number",
  "market-agency": "Agency",
  "market-bank": "Bank",
  "market-add-bank-account": "Add Bank Account",
  "market-no-account-registered": "No account registered",
  "market-credit-limit": "Credit limit",
  "market-add-distribution": "Add Distribution",
  "market-global-credit": "Global Credit",
  "market-limit-distribution": "Limit distribution",
  "market-no-credit-limit-registered": "No credit limit registered",
  "market-account": "Account",
  "market-accounts-count": "Number of accounts",
  "market-account-type": "Account type",
  "market-limit-type-registered-successfully": "Limit type registered successfully!",
  "market-checking": "Checking account",
  "market-savings": "Savings account",
  "market-investment": "Investment account",
  "market-retirement": "Retirement account",
  "market-credit": "Credit account",
  "market-loan": "Loan account",
  "market-joint": "Joint account",
  "market-business": "Business account",
  "market-student": "Student account",
  "market-trust": "Trust account",
  "market-payroll": "Payroll account",
  "market-cash-management": "Cash management account",
  "market-foreign-currency": "Foreign currency account",
  "market-crypto-currency": "Cryptocurrency account",
  "market-custodial": "Custodial account",
  "market-broker": "Brokerage account",
  "market-charity": "Charity account",
  "market-escrow": "Escrow account",
  "market-offshore": "Offshore account",
  "market-margin": "Margin account",
  "market-government": "Government account",
  "market-virtual": "Virtual account",
  "market-other": "Other",
  "market-bank-relationship1": "",
  "market-bank-relationship2": "",
  "market-bank-relationship3": "",
  "market-bank-relationship": "Balance relationship",
  "market-no-bank-account-registered": "No bank account registered!",
  "market-delete-bank-relationship": "Delete bank relationship?",
  "market-confirm-delete-bank-relationship": "Are you sure you want to delete this bank relationship?",
  "market-bank-relationship-deleted-successfully": "Bank relationship deleted successfully!",
  "market-delete-limit-distribution": "Delete limit distribution?",
  "market-delete-limit-distribution-confirmation": "Are you sure you want to delete this limit distribution?",
  "market-limit-distribution-excluded-successfully": "Limit distribution excluded successfully!",
  "market-bank-account-registered-successfully": "Bank account registered successfully!",
  "market-limit-distribution-registered-successfully": "Limit distribution registered successfully!",
  "market-limit-distribution-updated-successfully": "Limit distribution updated successfully!",
  "market-choose-financial-institutions": "Choose the Financial Institutions",
  "market-shared-folder-success": "Folder shared successfully!",
  "market-bank-accounts-list": "Bank Accounts List",
  "market-edit-bank-account": "Edit Bank Account",
  "market-company-documents": "Company documents",
  "market-company-files": "Company files",
  "market-link-copied-to-clipboard": "Link copied to clipboard",
  "market-share-with-financial-institutions": "Share with all financial institutions",
  "market-select-at-least-one-bank": "Select at least one bank",
  "market-download-selected": "Download Selected",
  "market-no-financial-institutions-registered1": "There are no registered financial institutions.",
  "market-register-new-bank-relationship": "Register New Bank Relationship",
  "market-add-limit-distribution": "Add Limit Distribution",
  "market-digit": "digit",
  "negotiation-credit-pipeline": "Credit Pipeline",
  "negotiation-negotiations-in-progress": "Ongoing Negotiations",
  "negotiation-new-negotiation": "New negotiation",
  "negotiation-select-company-to-view-current-negotiations": "Select a company to view ongoing negotiations",
  "negotiation-add-negotiation": "Add Negotiation",
  "negotiation-reference-name1": "Reference Name",
  "negotiation-reason-for-negotiation": "Reason for Negotiation",
  "negotiation-next-action-required": "Next action required",
  "negotiation-task-created-successfully": "Task created successfully",
  "negotiation-error-creating-task": "Error creating task",
  "negotiation-comment-created-successfully": "Comment created successfully",
  "negotiation-error-creating-comment": "Error creating comment",
  "negotiation-document-created-successfully": "Document created successfully",
  "negotiation-error-creating-document": "Error creating document",
  "negotiation-negotiation-successfully-created": "Negotiation created successfully",
  "negotiation-error-creating-negotiation": "Error creating negotiation",
  "negotiation-negotiation-successfully-updated": "Negotiation updated successfully",
  "negotiation-error-updating-negotiation": "Error updating negotiation",
  "negotiation-priority-changed-successfully": "Priority changed successfully!",
  "negotiation-error-changing-negotiation-priority": "Error changing the negotiation priority",
  "negotiation-negotiation-successfully-deleted": "",
  "negotiation-negotiation-removed-successfully": "Negotiation removed successfully",
  "negotiation-remove-negotiation": "Remove negotiation?",
  "negotiation-confirm-remove-negotiation": "Are you sure you want to remove the negotiation?",
  "negotiation-comment-deleted-successfully": "Comment deleted successfully",
  "negotiation-task-deleted-successfully": "Task deleted successfully",
  "onboarding-onboarding": "Onboarding",
  "onboarding-company-registration": "Company Registration",
  "onboarding-company-registration-subtitle": "Registering and sending your company's documents is essential so that we can carry out a detailed analysis. This will allow us to work with banks, ensuring efficiency and precision at all stages of financial solutions for your business.",
  "onboarding-progress": "Onboarding",
  "onboarding-company-information": "Company Information",
  "onboarding-contacts": "Contacts",
  "onboarding-document-upload": "Document upload",
  "onboarding-uploading-general-documents": "Uploading general documents",
  "onboarding-uploading-billing-documents": "Uploading billing documents",
  "onboarding-uploading-financial-statements": "Uploading financial statements",
  "onboarding-uploading-projects": "Uploading projects",
  "onboarding-uploading-warranty-documents": "Uploading warranty documents",
  "onboarding-sector": "Sector",
  "onboarding-do-onboarding": "Do onboarding",
  "onboarding-onboarding-completed-successfully": "Onboarding completed successfully",
  "onboarding-onboarding-saved-successfully": "Onboarding saved successfully",
  "onboarding-onboarding-updated": "Onboarding updated",
  "onboarding-error-updating-onboarding": "Error updating onboarding",
  "onboarding-company-contact-persons": "Company contact persons",
  "onboarding-accounting-contact-persons": "Account contact persons",
  "onboarding-financial-contact-persons": "Financial contact persons",
  "onboarding-area-position": "Area/Position",
  "onboarding-social-contract-contractual-changes": "Social contract and contractual changes",
  "onboarding-documentation-legal-representatives": "Documentation of legal representatives",
  "onboarding-income-tax-partners": "Income tax of partners",
  "onboarding-corporate-structure-map": "Corporate structure map",
  "onboarding-executive-organizational-chart": "Executive organizational chart",
  "onboarding-have-holding-company": "Do you have a holding company?",
  "onboarding-financial-statements-last3years": "Financial statements (last 3 years)",
  "onboarding-invalid-file-max-size": "Invalid file. Select a .pdf or .xlsx file up to 100 MB.",
  "onboarding-pdf-or-xlsx-files-up-to100-mb": ".pdf or .xlsx files up to 100 MB",
  "onboarding-pdf-files-up-to100-mb": ".pdf files up to 100 MB",
  "onboarding-pdf-xlsx-or-image-files-up-to100-mb": ".pdf, .xlsx or image (.jpg, .png) files up to 100 MB",
  "onboarding-pdf-xlsx-or-pptx-files-up-to100-mb": ".pdf, .xlsx or .pptx files up to 100 MB",
  "onboarding-xlsx-files-up-to100-mb": ".xlsx files up to 100 MB",
  "onboarding-jpg-or-png-files-up-to100-mb": ".jpg or .png files up to 100 MB",
  "onboarding-pdf-or-pptx-files-up-to100-mb": ".pdf or .pptx files up to 100 MB",
  "onboarding-pptx-files-up-to100-mb": ".pptx files up to 100 MB",
  "onboarding-required": "Required",
  "onboarding-optional": "Opcional",
  "onboarding-invalid-file": "Invalid file",
  "onboarding-select-pd-xlsx-file-up100-mb": "Select a .pdf or .xlsx file up to 100 MB",
  "onboarding-market-studies": "Market studies",
  "onboarding-institutional-presentation": "Institutional presentation",
  "onboarding-commercial-presentations": "Commercial presentations",
  "onboarding-presentations-information-products-services": "Presentations and information about products and services",
  "onboarding-company-images-products-services": "Company images, products and services",
  "onboarding-brand-manual": "Brand manual",
  "onboarding-logos-vector-jpg-png-formats": "Logos in vector, JPG and PNG formats",
  "onboarding-brand-pitch-deck": "Brand pitch deck",
  "onboarding-annual-billing": "Annual Billing",
  "onboarding-partial-billing-current-year": "Partial billing current year",
  "onboarding-balance-sheet-income-statement-ddc": "Balance sheet, income statement and DFC",
  "onboarding-monthly-balance-sheets-last3-years": "Monthly balance sheets last 3 years",
  "onboarding-business-plan": "Business plan",
  "onboarding-projections": "Projections",
  "onboarding-multi-year-financial-projection": "Multi-year financial projection",
  "onboarding-backlog-with-balance-projection": "Backlog with balance and projection",
  "onboarding-debt": "Debt",
  "onboarding-debt-projection": "Debt projection",
  "onboarding-edital": "Notice",
  "onboarding-loan-agreements": "Loan Agreements",
  "onboarding-physical-financial-schedule": "Physical-financial schedule",
  "onboarding-consortium-incorporation-document-ia": "Consortium incorporation document (if applicable)",
  "onboarding-general-information-sae": "Información general (estudios, análisis, etc...)",
  "onboarding-properties-registrations-evaluations": "Properties: registrations and evaluations",
  "onboarding-accounts-receivable-cdmr": "Accounts receivable (consent, deadline, means of receipt...)",
  "onboarding-contracts-customers": "Contracts with customers",
  "onboarding-send-onboarding": "Send onboarding",
  "onboarding-send-link": "Send link",
  "onboarding-choose-user-to-send-onboarding-link": "Choose the user to send the onboarding link",
  "onboarding-error-sending-onboarding-link": "Error sending onboarding link",
  "onboarding-registration-completed": "Registration completed",
  "onboarding-invitation-to-user-by-company-success": "The invitation to the user {{ email }} has been sent, he will receive an email to validate the data and once finished, we will notify you of the status.",
  "onboarding-file-upload-success": "File uploaded successfully!",
  "onboarding-company-documents1": "Company Documents",
  "onboarding-general-documents1": "General Documents",
  "onboarding-billing-documents1": "Billing Documents",
  "onboarding-financial-statements1": "Financial Statements",
  "onboarding-projects1": "Projects",
  "onboarding-warranty-documents1": "Warranty Documents",
  "onboarding-document-analysis2": "Document Analysis",
  "onboarding-mandatory-documents-submitted": "All mandatory documents submitted",
  "onboarding-documents-pending-delivery": "There are documents pending delivery",
  "onboarding-all-documents-approved": "All documents approved",
  "onboarding-documents-not-approved": "Documents submitted not yet approved",
  "onboarding-no-document-sent": "No document sent",
  "onboarding-approved1": "Approved",
  "onboarding-request-rejected": "Rejected",
  "onboarding-pending-analysis": "Pending analysis",
  "onboarding-analyzed-by-user": "Analyzed by {user} on {date}",
  "onboarding-sent-by-user-on-date": "Sent by {user} on {date}",
  "onboarding-annual-revenue-previous-years": "Annual Revenue (Previous Years)",
  "onboarding-balance-dre-dfc-previous-years": "Balance, DRE and DFC (Previous Years)",
  "risk-panel-currency-expiration": "Currency / Expiration",
  "risk-panel-future-value-brazilian-real": "Future Value (BRL)",
  "risk-panel-weighted-capital": "Weighted Capital",
  "risk-panel-effective-current-loss-cap-brl": "Effective Current Loss CAP (BRL)",
  "risk-panel-loss-percentage-current": "Current Loss %",
  "risk-panel-scenario-brl": "Scenario (BRL)",
  "risk-panel-average-weighted-cost": "Average Weighted Cost",
  "risk-panel-partial-hedge-economy": "Partial Hedge Economy",
  "risk-panel-cap-exhibition": "CAP Exhibition",
  "risk-panel-monthly-exhibition": "Monthly exhibition",
  "risk-panel-average-spot-ref": "Average Spot Ref.",
  "risk-panel-average-price": "Average Price",
  "risk-panel-average-total-cost": "Average Total Cost",
  "risk-panel-partial-hedge-economy-brl": "Partial Hedge Economy BRL",
  "risk-panel-average-cost-perfect-hedge": "Average Cost of Perfect Hedge",
  "risk-panel-average-margin-cap": "Average Margin CAP",
  "risk-panel-current-parity": "Current Parity",
  "risk-panel-current-actual-loss-cap": "Current Actual Loss CAP",
  "risk-panel-current-loss": "Current Loss",
  "risk-panel-loss1": "Loss",
  "risk-panel-future-due-dates": "Future Due Dates",
  "risk-panel-passive-future-due-dates": "Passive Future Due Dates",
  "risk-panel-realized-economy": "Realized Economy",
  "risk-panel-estimated-economy": "Estimated Economy",
  "risk-panel-synthetic-vision": "Synthetic Vision",
  "risk-panel-total-volume": "Total volume",
  "risk-panel-net-result": "net result",
  "risk-panel-partial-hedge-economics": "Partial hedge economics",
  "risk-panel-average-term-in-days": "average term in days",
  "risk-panel-current-loss-and-percentage": "Current loss and %",
  "risk-panel-annual-hedge-cost": "Annual hedge cost",
  "risk-panel-total-amount-and-protected-amount": "Total amount and protected amount",
  "risk-panel-estimated-economy1": "estimated economy",
  "risk-panel-future-value-vs-cap-vs-spot": "Future value at maturity vs CAP vs SPOT",
  "risk-panel-current-loss-estimate-vs-scenarios": "Current loss estimate vs Scenarios",
  "risk-panel-total-general-brl": "Total General BRL",
  "risk-panel-company-parity": "Company/Parity",
  "risk-panel-margin-of-cap-percentage": "Margin of CAP (%)",
  "risk-panel-future-value-brl": "Future Value (BRL)",
  "risk-panel-spot-ref1": "Spot Ref.",
  "risk-panel-price-ndf": "Price (NDF)",
  "risk-panel-total-cost-yearly-percentage": "Total Cost (yearly) (%)",
  "risk-panel-partial-hedge-economy-brl1": "Economy BRL Partial hedge (%)",
  "risk-panel-perfect-cost-brl": "Perfect Cost (BRL)",
  "risk-panel-margin-cap-percentage": "CAP Margin (%)",
  "risk-panel-current-parity1": "Current Parity",
  "risk-panel-usd-pricing": "USD Pricing",
  "risk-panel-current-effectively-lost-cap-brl": "Current Effective Loss CAP (BRL)",
  "risk-panel-current-loss-percentage": "Current Loss (%)",
  "risk-panel-loss-scenario": "Loss scenario",
  "risk-panel-current-effective-loss-cap-pec": "Current Effective Loss CAP (PEC)",
  "risk-panel-partial-hedge-economy-brl2": "Partial hedge economy (BRL)",
  "risk-panel-value-brazilian-reais-thousands": "Value (BRL Thousands)",
  "risk-panel-amount-not-protected": "Amount not protected",
  "risk-panel-protected-amount1": "protected amount",
  "risk-panel-weighted-average": "weighted cap",
  "risk-panel-currency-fluctuation-sensitivity-slider": "Use this slider to adjust the sensitivity of the currency fluctuations",
  "risk-panel-sensitivity-parameters-visibility": "Here you can see the sensitivity parameters.",
  "risk-panel-exchange-rates-and-variations": "Here are the exchange rates and their variations.",
  "risk-panel-select-desired-currency-pair-here": "Select the desired currency pair here.",
  "risk-panel-operation-type-choice-comex-loan": "Choose the type of operation between COMEX and loan.",
  "risk-panel-annual-hedge-cost-percentage1": "Inform the annual hedge cost as a percentage.",
  "risk-panel-estimated-annual-economy": "Estimated Annual Economy",
  "risk-panel-no-operations-for-selected-filters": "There are no operations for the selected filters",
  "risk-panel-passive-future-expirations-id": "ID Operation",
  "risk-panel-value-local-currency-input": "Input (BRL)",
  "risk-panel-value-local-currency-output": "Output (BRL)",
  "risk-panel-conversion-tax": "Conversion Rate",
  "risk-panel-variation": "Variation (%)",
  "user-permission-insert": "Insert",
  "user-permission-save": "Save",
  "user-permission-cancel": "Cancel",
  "user-permission-delete": "Delete",
  "user-permission-update": "Update",
  "user-permission-no-group-registered": "No groups registered",
  "user-users": "Users",
  "user-administration": "Administration",
  "user-all": "All",
  "user-active": "Active",
  "user-inactive": "Inactive",
  "user-disabled": "Disabled",
  "user-pending": "Pending",
  "user-actives": "Active",
  "user-inactives": "Inactive",
  "user-disableds": "Disabled",
  "user-pendings": "Pending",
  "user-no-profile-registered": "No profile registered",
  "user-to-add": "Add",
  "user-add-user": "Add user",
  "user-edit-user": "Edit user",
  "user-cancel": "Cancel",
  "user-finish": "Finish",
  "user-information": "Information",
  "user-user-type": "User type",
  "user-name": "Name",
  "user-first-name": "First name",
  "user-second-name": "Second name",
  "user-lastname": "Surname",
  "user-function": "Function",
  "user-profile": "Profile",
  "user-email": "Email",
  "user-phone": "Phone",
  "user-type": "Type",
  "user-localization": "Localization",
  "user-language": "Language",
  "user-date-format": "Date format",
  "user-time-format": "Time format",
  "user-timezone": "Time zone",
  "user-status": "Status",
  "user-select": "Select",
  "user-permissions-group": "Permissions Group",
  "user-selected": "selected",
  "user-mark-all": "All",
  "user-new-group": "New group",
  "user-permissions": "Permissions",
  "user-tenant": "Tenant",
  "user-group-created-successfully": "User group created successfully",
  "user-group-updated-successfully": "User group updated successfully",
  "user-group-deleted-successfully": "User group successfully removed",
  "user-user-created-successfully": "User created successfully",
  "user-user-updated-successfully": "User updated successfully",
  "user-user-deleted-successfully": "User successfully removed",
  "user-user-title-delete-confirmation": "Are you sure you want to delete this user?",
  "user-user-description-delete-confirmation": "The user will lose all access to the system.",
  "user-user-group-title-delete-confirmation": "Are you sure you want to delete this group?",
  "user-user-group-description-delete-confirmation": "The group will be removed from the system.",
  "user-user-error-loading-users": "Error loading users",
  "user-user-error-loading-user": "Error loading user",
  "user-user-error-removing-user": "Error removing user",
  "user-user-error-loading-groups": "Error loading groups",
  "user-user-error-loading-group": "Error loading group",
  "user-user-error-removing-group": "Error removing group",
  "user-user-error-loading-roles": "Error loading roles",
  "user-user-error-loading-role": "Error loading role",
  "user-user-error-removing-role": "Error removing role",
  "user-user-error-loading-languages": "Error loading languages",
  "user-user-error-loading-date-formats": "Error loading date formats",
  "user-user-error-loading-time-formats": "Error loading time formats",
  "user-user-error-loading-timezones": "Error loading timezones",
  "user-user-error-loading-permissions": "Error loading permissions",
  "user-user-error-loading-permission": "Error loading permission",
  "user-user-error-removing-permission": "Error removing permission",
  "user-user-error-creating-user": "Error creating user",
  "user-user-error-updating-user": "Error updating user",
  "user-user-error-creating-permissions-group": "Error creating permissions group",
  "user-user-error-updating-permissions-group": "Error updating permissions group",
  "user-user-error-removing-permissions-group": "Error removing permissions group",
  "user-permissions-group-removed-successfully": "Permissions group removed successfully",
  "user-change": "Change",
  "user-no-user-found": "No user found",
  "user-manage-users": "Manage Users",
  "user-last-login": "Last Login",
  "user-has-password": "Has Password",
  "validation-enter-valid-email": "Please enter a valid email",
  "validation-field-required": "This field is required",
  "validation-field-error": "Field Error",
  "validation-minlength": "Minimum allowed length is {0} characters",
  "validation-maxlength": "Maximum allowed length is {0} characters",
  "validation-password-mismatch": "Passwords do not match",
  "management-loan-operation-origins": "Loan Operation Origins",
  "management-manage-external-origins": "Manage External Origins",
  "management-register-origin": "Register Origin",
  "management-no-origins-registered": "No origins registered",
  "management-register-first-origin-funding": "Register the first funding origin for this financial institution.",
  "management-funding-origin": "Funding Origin",
  "management-select-origin": "Select origin",
  "management-select-origin-funding-tooltip": "Select the funding origin for this operation.",
  "management-register-new": "Register new",
  "management-edit-funding-origin": "Edit Funding Origin",
  "management-create-funding-origin": "Create Funding Origin",
  "management-country": "Country",
  "management-enter-country": "Enter country",
  "management-select-country": "Select country",
  "management-select-country-first": "Select a country first",
  "management-city": "City",
  "management-enter-city-optional": "Enter city (optional)",
  "management-select-city-optional": "Select city (optional)",
  "management-country-field-required": "Country field is required",
  "management-financial-institution-not-selected": "Financial institution not selected",
  "management-origin-updated-successfully": "Origin updated successfully",
  "management-origin-created-successfully": "Origin created successfully",
  "management-error-updating-origin": "There was an error updating the origin",
  "management-error-creating-origin": "There was an error creating the origin",
  "management-delete-origin": "Delete Origin",
  "management-confirm-delete-origin": "Do you really want to delete the origin \"{0}\"?",
  "management-origin-deleted-successfully": "Origin deleted successfully",
  "management-error-deleting-origin": "Error deleting origin",
  "management-error-loading-origins": "Error loading origins"
}
